import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'

import Message from '../message'
import {
  Container,
  Option,
  Radio,
  RadioCheck,
  Label,
  LabelOnlyText,
  ErrorContainer
} from './styled'

export const RadioGroup = props => {
  const radioGroupId = useMemo(() => uuid(), [])
  const { t } = useTranslation()

  const renderMessage = (content, type) => (
    <ErrorContainer
      e2eClass={props.e2eClass || props.name}
      withPaddingError={props.withPaddingError}
    >
      <Message e2eClass={props.e2eClass} type={type}>
        {content}
      </Message>
    </ErrorContainer>
  )

  return (
    <>
      <Container
        horizontal={props.horizontal}
        noFullwidth={props.noFullwidth}
        wrap={String(props.wrap)}
        paddingTop={props.paddingTop}
        ariaActive={`${radioGroupId}-${props.options.indexOf(
          props.options.find(option => option.selected)
        )}`}
        role="radiogroup"
        aria-label={props.ariaLabel || t('general.radio-group.label')}
      >
        {props.options.map(({ value, text, selected, e2eClass }, index) => {
          const radioId = `${radioGroupId}-${index}`
          return (
            <Option
              key={index}
              noMargin={props.noMargin}
              paddingBottom={props.paddingBottomOption}
              optionList={props.optionList}
              id={`option-${radioId}`}
            >
              {!props.onlyText ? (
                <>
                  <Radio
                    id={radioId}
                    e2eClass={e2eClass}
                    name={props.name}
                    value={value}
                    checked={selected}
                    disabled={props.disabled}
                    onChange={() => props.onChange(value, props.name)}
                    onKeyDown={e => props.onKeyDown && props.onKeyDown(e, value)}
                    noMargin={props.noMargin}
                    optionList={props.optionList}
                  />
                  <RadioCheck disabled={props.disabled} checked={selected} />
                </>
              ) : (
                <LabelOnlyText
                  id={radioId}
                  e2eClass={e2eClass}
                  name={props.name}
                  selected={selected}
                  fontSize={props.fontSize}
                  htmlFor={radioId}
                  value={value}
                  checked={selected}
                  disabled={props.disabled}
                  onChange={props.onChange}
                />
              )}
              <Label
                e2eClass={e2eClass}
                onlyText={props.onlyText}
                fontSize={props.fontSize}
                color={props.color}
                optionList={props.optionList}
                htmlFor={radioId}
              >
                {text}
              </Label>
            </Option>
          )
        })}
      </Container>
      {props?.error && renderMessage(props.error, 'formInputError')}
    </>
  )
}

export const RadioGroupOnlyText = props => <RadioGroup {...props} onlyText />
